import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	EventEmitter,
	Inject,
	Input,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { NgModel } from '@angular/forms';

import { CarrierLanesTable, IS_NOT_EMPTY, RestService, TruckLane } from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { SEARCHABLE_TRAILER_TYPES_FOR_ADMIN } from '@domain/constants/searchable-trailer-types';
import { CarrierEquipmentDataService } from '../../admin/carrier-equipment/carrier-equipment-data.service';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { environment } from '@environment/environment';

@Component({
	selector: 'app-add-lane',
	templateUrl: './add-lane.component.html',
	styleUrls: ['./add-lane.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddLaneComponent implements OnInit {
	@Input() carrierId;
	@Input() oldCarrierId;
	@Input() editLane;
	@Input() usePublicCreateLane;
	@Input() lane: CarrierLanesTable;
	@Input() isDisabled;
	@Input() inputConfig: any = {
		origin: false,
		trailerType: false,
		destination: false,
	};

	@Input() runsReverseLaneText: string = 'Runs Reverse Lane';
	@Input() fromCarrier: boolean = false;
	@Output() laneAdded: EventEmitter<any> = new EventEmitter();
	@Output() laneUpdated: EventEmitter<any> = new EventEmitter();

	constructor(public dialog: MatDialog, public utilService: UtilService) {}

	ngOnInit() {}

	openAddLaneForm() {
		const dialogRef = this.dialog.open(AddLaneDialog, {
			width: '950px',
			data: {
				editLane: this.editLane,
				usePublicCreateLane: this.usePublicCreateLane,
				carrierId: this.carrierId,
				oldCarrierId: this.oldCarrierId,
				lane: this.lane || null,
				inputConfig: this.inputConfig,
				runsReverseLaneText: this.runsReverseLaneText,
				fromCarrier: this.fromCarrier,
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (!this.utilService.isNullOrUndefined(result)) {
				if (!result.isUpdate) {
					this.laneAdded.emit(result);
				} else if (result.isUpdate) {
					this.laneUpdated.emit(result);
				}
			}
		});
	}
}

@Component({
	selector: 'app-add-lane-dialog',
	templateUrl: 'modal.template.html',
})
export class AddLaneDialog implements OnInit {
	@ViewChild('div') divElement: ElementRef;
	@ViewChild('originInput') originInput: ElementRef<HTMLElement>;

	trailerTypes = [];
	origin;
	model: TruckLane = {
		id: null,
		carrierId: null,
		oldCarrierId: null,
		trailerType: null,
		originCity: '',
		originState: '',
		destCity: '',
		destState: '',
		destinationStates: null,
		originZip: '',
		originLat: null,
		originLng: null,
		destZip: '',
		destLat: null,
		destLng: null,
		hasBackhaulLane: false,
		createBackhaulLanes: false,
		runsReverseLane: false,
		weeklyFrequency: 1,
		runDaily: false,
		monday: false,
		tuesday: false,
		wednesday: false,
		thursday: false,
		friday: false,
		saturday: false,
		sunday: false,
		truckLaneId: null,
		age: null,
		carrierLaneId: null,
		destinationDeadhead: null,
		rate: null,
		rateUpdatedAt: null,
		fromCarrier: false,
		toBeReviewed: false,
		confirmationDate: null,
		originDeadheadLimit: null,
		destinationDeadheadLimit: null,
		ltl: false,
	};
	weeklyFrequencyList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	isRequestInProgress = false;

	isCarrierLoggedIn: boolean = false;
	laneEdited: TruckLane = null;
	isAdmin: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<AddLaneDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private urlService: UrlService,
		private restService: RestService,
		public utilService: UtilService,
		private carrierEquipmentService: CarrierEquipmentDataService,
		private cargoChief: Cargochief,
		private segmentWrapper: SegmentWrapperService
	) {
		this.model.carrierId = this.data.carrierId;
		this.model.oldCarrierId = this.data.oldCarrierId;
		this.isAdmin = this.utilService.isAccountTypeAdmin();
		if (this.data.editLane) {
			const lane = this.data.lane;
			const { origin, destination, originMetadata, destinationMetadata, ...remainingData } = lane;
			this.model = { ...remainingData };
			const originSplit = !this.utilService.isNullOrUndefined(origin) ? origin.split(', ') : '';
			if (!this.utilService.isNullOrUndefined(originSplit) && originSplit.length > 1) {
				this.model.originCity = originSplit[0];
				this.model.originState = originSplit[1];
				this.origin = this.model.originCity + ', ' + this.model.originState;
			} else {
				this.model.originState = originSplit[0];
				this.origin = this.model.originState;
			}
			if (!this.utilService.isNullOrUndefined(destination) && IS_NOT_EMPTY(destination)) {
				this.model.destCity = destination.split(', ')[0];
				this.model.destState = destination.split(', ')[1];
			}
			this.model.originLat = lane.originMetadata.latitude;
			this.model.originLng = lane.originMetadata.longitude;
			this.model.originZip = lane.originMetadata.zip;
			this.model.destLat = lane.destinationMetadata.latitude;
			this.model.destLng = lane.destinationMetadata.longitude;
			this.model.destZip = lane.destinationMetadata.zip;
			this.laneEdited = Object.assign({}, this.model);
			this.model.ltl = lane.ltl;
			console.log('lane: ', lane);
		}
		setTimeout(() => {
			if (!this.utilService.isNullOrUndefined(this.originInput.nativeElement)) {
				this.originInput.nativeElement.blur();
			}
		}, 400);
	}

	ngOnInit() {
		SEARCHABLE_TRAILER_TYPES_FOR_ADMIN.forEach((trailer) => {
			this.trailerTypes.push({ dbVal: trailer.trim().toUpperCase(), value: trailer });
		});
		if (!this.data.editLane) {
			this.model.trailerType = this.trailerTypes[0].dbVal;
		}

		if (this.cargoChief.CARRIER?.id && this.cargoChief.CARRIER.id === this.data.carrierId) {
			this.isCarrierLoggedIn = true;
		}
		this.model.fromCarrier = this.model.toBeReviewed = this.data.fromCarrier;
	}

	getAddressOnChange($event, control: NgModel) {
		if (control.name === 'origin') {
			this.model.originCity = $event.city;
			this.model.originState = $event.state;
			this.model.originLat = $event.latitude;
			this.model.originLng = $event.longitude;
			this.model.originZip = $event.zip;
		}
	}

	destinations(event) {
		this.model.destCity = event.destCity;
		this.model.destState = event.destState;
		this.model.destLat = event.destLat;
		this.model.destLng = event.destLng;
		this.model.destZip = event.destZip;
		this.model.destinationStates = event.destinationStates;
		if (!this.utilService.isNullOrUndefined(this.divElement)) {
			this.divElement.nativeElement.click();
		}
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	usePublicCreateLane() {
		const url = this.urlService.createLane();
		this.postLane(url);
	}

	addNewTruckLane() {
		const url = this.urlService.addNewTruckLane();
		this.postLane(url);
	}

	postLane(url: string) {
		this.isRequestInProgress = true;
		this.fireSegmentEvent();
		this.restService.POST(url, this.model).subscribe(
			(result) => {
				this.isRequestInProgress = false;
				this.utilService.showSnackbar(
					'Lane added successfully.',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				result.data['isUpdate'] = false;
				this.dialogRef.close(result.data);
				this.addEquipmentForCarrier(this.model);
			},
			(error) => {
				this.handleError(error);
			}
		);
	}

	fireSegmentEvent() {
		if (this.utilService.isAccountTypeCarrier()) {
			const payload = {
				carrier: {
					name: this.cargoChief.BUSINESS_NAME,
					mc: this.cargoChief.MC,
					dot: this.cargoChief.DOT,
				},
				lane: this.model,
			};
			this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.carrier_added_lane, payload);
		}
	}

	isFormInvalid() {
		if (
			IS_NOT_EMPTY(this.model.originCity) &&
			IS_NOT_EMPTY(this.model.originState) &&
			((IS_NOT_EMPTY(this.model?.destCity) && IS_NOT_EMPTY(this.model?.destState)) ||
				this.model?.destinationStates?.length > 0)
		) {
			return false;
		} else {
			return true;
		}
	}

	updateLane() {
		this.isRequestInProgress = true;
		const url = this.urlService.updateLane();
		if (this.isCarrierLoggedIn) {
			this.fireCarrierUpdateLaneEvent();
		}
		let payload: TruckLane = Object.assign({}, this.model);
		if (payload?.destinationStates?.constructor === Array) {
			const destinationStates: Array<string> = payload.destinationStates;
			payload.destinationStates = destinationStates.join(', ');
		}
		this.restService.POST(url, payload).subscribe(
			(result) => {
				this.isRequestInProgress = false;
				this.utilService.showSnackbar(
					'Lane updated successfully.',
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				result.data['isUpdate'] = true;
				this.dialogRef.close(result.data);
				this.addEquipmentForCarrier(this.model);
			},
			(error) => {
				this.handleError(error);
			}
		);
	}

	fireCarrierUpdateLaneEvent() {
		let changedProperties = {};
		Object.keys(this.model)
			.filter((k) => this.model[k] !== this.laneEdited[k])
			.filter((key) => key != 'updatedAt')
			.filter((key) => {
				changedProperties[key] = this.model[key];
			});
		changedProperties = JSON.stringify(changedProperties)
			.replace(/\"/g, '')
			.replace(/\{/g, '')
			.replace(/\}/g, '');
		const payload: any = {
			lane: this.model,
			carrier: this.cargoChief.CARRIER,
			url: `${environment.clientUrl}admin/carrier_profile/${this.data.carrierId}`,
			updated: changedProperties,
		};
		this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.carrier_updated_lane, payload);
	}

	handleError(error: any) {
		const errorMessage = error['error'] || 'Unable to complete your request now.';
		this.utilService.showSnackbar(errorMessage, SNACKBAR.ERROR, SNACKBAR.ACTION);
		this.isRequestInProgress = false;
	}

	addEquipmentForCarrier(dataModel: TruckLane) {
		this.carrierEquipmentService.pushLaneCount(this.carrierEquipmentService.laneCount + 1);
		const equipment = this.carrierEquipmentService.mapTrailerTypeToEquipment(dataModel.trailerType);
		if (!this.utilService.isNullOrUndefined(equipment)) {
			if (!this.carrierEquipmentService.isInEquipmentList(equipment)) {
				this.carrierEquipmentService
					.addEquipmentForCarrier(dataModel.carrierId, equipment.id)
					.then((results) => {
						this.carrierEquipmentService.equipmentList.push(equipment);
						this.carrierEquipmentService.push(this.carrierEquipmentService.equipmentList);
					})
					.catch((error) => {
						const msg = error['error'] || 'Unable to add equipment for carrier.';
						this.utilService.showSnackbar(msg, SNACKBAR.ERROR, SNACKBAR.ACTION);
					});
			}
		}
	}

	resetRunDaily(): void {
		this.model.runDaily = false;
	}
}
